import type { Translation } from "./types";

const ko: Translation = {
  home: {
    title: "윤찬욱레슬링",
    subtitle: "레슬링하는 시간이야!",
    heroTitle: "몸과 마음을 단단하게 만드는 <aurora>레슬링</aurora>",
    heroDescription:
      "모두가 함께 성장하는 <highlight>윤찬욱레슬링</highlight>에서 기본기부터 실전 감각까지 체계적으로 훈련합니다.",
    ctaPrimary: "무료 체험 신청",
    ctaSecondary: "시간표 보기",
    heroMediaPlaceholder: "히어로 이미지 슬라이드 영역",
    heroMediaHint: "관원 훈련 사진, 단체 사진, 선수부 시합/메달 사진 등",
    directionsEyebrow: "오시는 길",
    directionsTitle: "체육관 위치 안내",
    directionsDescription:
      "윤찬욱레슬링 체육관은 경기 평택시 경기대로 1409 4층에 위치해 있습니다.",
    directionsAddressLabel: "주소",
    directionsAddress: "경기 평택시 경기대로 1409 4층",
    directionsMapButton: "구글맵으로 보기",
  },
  navigation: {
    kr: "한국어",
    ja: "일본어",
    en: "영어",
    dashboard: "대시보드",
    logout: "로그아웃",
    signIn: "로그인",
    signUp: "회원가입",
    home: "홈",
    about: "소개",
    gym: "체육관",
    gymDescription: "체육관 소개",
    coach: "관장",
    coachDescription: "관장 소개",
    facilities: "시설",
    facilitiesDescription: "시설 소개",
    programs: "프로그램",
    info: "프로그램 소개",
    infoDescription: "통합 훈련 프로그램 소개",
    schedule: "시간표",
    scheduleDescription: "훈련 시간표",
    amateur: "아마추어 프로그램",
    amateurDescription: "생활체육 및 취미반 훈련 프로그램 소개",
    elite: "엘리트 프로그램",
    eliteDescription: "엘리트 선수반 훈련 프로그램 소개",
    community: "커뮤니티",
    announcements: "공지사항",
    announcementsDescription: "체육관 공지사항 및 이벤트 안내",
    news: "체육관 소식",
    newsDescription: "체육관 소식 및 대회 결과 안내",
    posts: "자유게시판",
    postsDescription: "체육관 회원 전용 자유게시판",
    etc: "기타",
    faq: "자주 묻는 질문",
    faqDescription: "자주 묻는 질문 및 답변",
    contact: "문의",
    contactDescription: "체육관 상담 및 문의",
    dashboardOverview: "개요",
    attendance: "출석체크",
    attendanceQr: "오늘 출석 QR",
    crewAttendance: "관원 출석 관리",
    membersManagement: "회원 관리",
  },
  announcementsPage: {
    metaDescription: "윤찬욱레슬링 공지사항 및 안내입니다.",
    colNumber: "번호",
    colTitle: "제목",
    colCategory: "구분",
    colDate: "등록일",
    colViews: "조회수",
    pinned: "고정",
    categoryGeneral: "일반",
    categoryEvent: "행사",
    categoryHoliday: "휴관",
    prev: "이전",
    next: "다음",
    rangeSummary: "전체 {{total}}건 중 {{start}}–{{end}}",
    empty: "등록된 공지사항이 없습니다.",
    paginationAria: "공지사항 페이지 이동",
    adminNew: "공지 작성",
    adminEdit: "수정",
    adminDelete: "삭제",
    adminSave: "저장",
    adminCancel: "취소",
    adminActions: "관리",
    formTitle: "제목",
    formBody: "내용",
    formCategory: "구분",
    formPublishedAt: "게시일",
    formPublishedAtHint: "비워두면 오늘 날짜로 저장됩니다.",
    formPinned: "상단 고정",
    createTitle: "공지 작성",
    editTitle: "공지 수정",
    deleteConfirm: "이 공지를 삭제할까요? 되돌릴 수 없습니다.",
    deleteSubmit: "삭제",
    saving: "저장 중…",
    errorGeneric: "문제가 발생했습니다.",
    detailBackToList: "목록으로",
    detailNotFoundTitle: "공지를 찾을 수 없습니다",
    detailNotFoundDescription: "삭제되었거나 잘못된 주소일 수 있습니다.",
    detailInvalidId: "잘못된 공지 링크입니다.",
  },
  newsPage: {
    metaDescription: "윤찬욱레슬링 체육관 소식과 사진입니다.",
    empty: "등록된 소식이 없습니다.",
    rangeSummary: "전체 {{total}}건 중 {{start}}–{{end}}",
    prev: "이전",
    next: "다음",
    paginationAria: "소식 페이지 이동",
    colViews: "조회수",
    readMore: "자세히 보기",
    adminNew: "소식 작성",
    adminEdit: "수정",
    adminDelete: "삭제",
    adminSave: "저장",
    adminCancel: "취소",
    formTitle: "제목",
    formBody: "내용",
    formImages: "사진",
    formImagesHint:
      "JPEG, PNG, WebP, GIF만 가능합니다. 최대 8장, 파일당 5MB 이하.",
    formPublishedAt: "게시일",
    formPublishedAtHint: "비워두면 오늘 날짜로 저장됩니다.",
    addImages: "추가",
    removeImage: "사진 제거",
    imagesMax: "사진은 최대 8장까지 올릴 수 있습니다.",
    imagesTooLarge: "파일당 5MB 이하여야 합니다.",
    imagesInvalidType: "이미지 파일만 업로드할 수 있습니다.",
    uploadNeedSignIn: "관리자로 로그인한 뒤 업로드하세요.",
    noSupabaseClient: "업로드할 수 없습니다(설정 누락).",
    createTitle: "소식 작성",
    editTitle: "소식 수정",
    deleteConfirm:
      "이 소식을 삭제할까요? 저장소의 사진도 함께 삭제되며 되돌릴 수 없습니다.",
    deleteSubmit: "삭제",
    saving: "저장 중…",
    errorGeneric: "문제가 발생했습니다.",
    detailBackToList: "목록으로",
    detailNotFoundTitle: "소식을 찾을 수 없습니다",
    detailNotFoundDescription: "삭제되었거나 잘못된 주소일 수 있습니다.",
    detailInvalidId: "잘못된 소식 링크입니다.",
  },
  postsPage: {
    metaDescription: "체육관 회원 전용 자유게시판 (준비 중).",
    comingSoon: "자유게시판은 추후 개발을 검토 중입니다.",
  },
  contactPage: {
    metaTitle: "문의",
    metaDescription:
      "등록 상담·무료 체험·방문 문의를 전화, 카카오톡, 인스타그램, WhatsApp, 이메일로 연결합니다.",
    eyebrow: "문의",
    heroTitle: "상담과 무료 체험을 편한 채널로 바로 연결하세요.",
    heroDescription:
      "등록 상담은 카카오톡 상담방으로, 무료 체험은 별도 오픈채팅방으로 연결됩니다. 전화, 인스타그램, WhatsApp, 이메일도 편한 방식으로 이용해 주세요.",
    trialCardTitle: "무료 체험 신청",
    trialCardDescription: "무료 체험 문의만 별도로 받는 1:1 오픈채팅방입니다.",
    trialCardCta: "무료 체험 오픈채팅 연결",
    phoneTitle: "전화 상담",
    phoneDescription: "가장 빠르게 상담을 원하시면 바로 전화해 주세요.",
    phoneCta: "전화 걸기",
    kakaoTitle: "카카오톡 상담",
    kakaoDescription:
      "등록 상담, 수업 문의, 방문 예약을 카카오톡으로 연결합니다.",
    kakaoValue: "1:1 상담 오픈채팅",
    kakaoCta: "카카오톡 상담하기",
    instagramTitle: "인스타그램",
    instagramDescription:
      "체육관 소식과 훈련 분위기를 확인하고 DM으로 문의하세요.",
    instagramValue: "@ycuwrestling",
    instagramCta: "인스타그램 보기",
    whatsappTitle: "WhatsApp",
    whatsappDescription:
      "해외 번호 또는 영어 상담이 편하신 분은 WhatsApp을 이용해 주세요.",
    whatsappCta: "WhatsApp으로 문의",
    emailTitle: "이메일",
    emailDescription:
      "사진, 문서 등 자세한 내용을 보내야 할 때 이메일을 이용해 주세요.",
    emailCta: "이메일 보내기",
    noteTitle: "문의 전 참고해 주세요",
    noteDescription:
      "등록 상담과 무료 체험 문의가 섞이지 않도록 버튼을 분리했습니다. 상담을 원하시면 카카오톡 상담방을, 첫 체험 예약은 무료 체험 오픈채팅방을 이용해 주세요.",
  },
  accountPage: {
    loadProfileError: "프로필을 불러오지 못했습니다.",
    loadSocialError: "소셜 계정 정보를 불러오지 못했습니다.",
    errorCodeLabel: "코드",
    errorMessageLabel: "메시지",
    editProfileTitle: "프로필 수정",
    editProfileDescription: "프로필 정보를 관리합니다.",
    avatarLabel: "아바타",
    avatarMaxSize: "최대 크기: 2MB",
    avatarAllowedFormats: "허용 형식: PNG, JPG, GIF",
    nameLabel: "이름",
    marketingConsentLabel: "마케팅 이메일 수신에 동의합니다",
    saveProfile: "프로필 저장",
    profileUpdated: "프로필이 업데이트되었습니다",
    changeEmailTitle: "이메일 변경",
    addEmailTitle: "이메일 추가",
    changeEmailDescription: "이메일 주소를 변경합니다.",
    addEmailDescription: "계정에 이메일 주소를 추가합니다.",
    currentEmailLabel: "현재 이메일",
    newEmailLabel: "새 이메일",
    changeEmailButton: "이메일 변경",
    addEmailButton: "이메일 추가",
    emailUpdateStarted:
      "이메일 변경 절차가 시작되었습니다. 기존 이메일의 인증 링크를 확인해 주세요.",
    changePasswordTitle: "비밀번호 변경",
    addPasswordTitle: "비밀번호 추가",
    changePasswordDescription: "비밀번호를 변경합니다.",
    addPasswordDescription: "계정에 비밀번호를 추가합니다.",
    newPasswordLabel: "새 비밀번호",
    confirmNewPasswordLabel: "새 비밀번호 확인",
    changePasswordButton: "비밀번호 변경",
    addPasswordButton: "비밀번호 추가",
    passwordUpdated: "비밀번호가 업데이트되었습니다",
    socialAccountsTitle: "소셜 계정 연결",
    socialAccountsDescription:
      "계정에 추가 인증 수단을 연결하거나 해제할 수 있습니다.",
    dangerZoneTitle: "위험 구역",
    confirmDeleteLabel: "내 계정을 삭제하는 데 동의합니다.",
    confirmIrreversibleLabel: "이 작업은 되돌릴 수 없음을 이해했습니다.",
    deleteAccountButton: "계정 삭제",
  },
  authPage: {
    loginTitle: "계정에 로그인",
    loginDescription: "정보를 입력해 주세요",
    joinTitle: "계정 만들기",
    joinDescription: "회원가입 정보를 입력해 주세요",
    nameLabel: "이름",
    namePlaceholder: "이름",
    emailLabel: "이메일",
    emailPlaceholder: "name@example.com",
    passwordLabel: "비밀번호",
    passwordHint: "최소 8자 이상이어야 합니다.",
    passwordPlaceholder: "비밀번호를 입력하세요",
    confirmPasswordLabel: "비밀번호 확인",
    confirmPasswordPlaceholder: "비밀번호를 한 번 더 입력하세요",
    forgotPassword: "비밀번호를 잊으셨나요?",
    loginButton: "로그인",
    createAccountButton: "계정 만들기",
    marketingLabel: "마케팅 이메일 수신에 동의합니다",
    termsPrefix: "다음 약관을 읽고 동의합니다:",
    termsOfService: "이용약관",
    and: "및",
    privacyPolicy: "개인정보처리방침",
    accountCreatedTitle: "계정이 생성되었습니다!",
    accountCreatedDescription:
      "로그인하기 전에 이메일 인증을 완료해 주세요. 이 탭은 닫아도 됩니다.",
    emailNotConfirmedTitle: "이메일이 인증되지 않았습니다",
    emailNotConfirmedDescription: "로그인 전에 이메일 인증을 완료해 주세요.",
    resendEmailButton: "인증 메일 다시 보내기",
    noAccountPrompt: "계정이 없으신가요?",
    signUpLink: "회원가입",
    alreadyHaveAccountPrompt: "이미 계정이 있으신가요?",
    signInLink: "로그인",
    continueWith: "{{provider}}로 계속하기",
    or: "또는",
    errorInvalidEmail: "올바른 이메일 주소가 아닙니다",
    errorPasswordMin: "비밀번호는 최소 8자 이상이어야 합니다",
    errorNameRequired: "이름을 입력해 주세요",
    errorPasswordsMustMatch: "비밀번호가 일치하지 않습니다",
    errorMustAgreeTerms: "이용약관에 동의해야 합니다",
    errorEmailExists: "이미 해당 이메일로 등록된 계정이 있습니다.",
    errorEmailNotConfirmed: "이메일이 인증되지 않았습니다",
    errorCaptchaFailed: "보안 검증에 실패했습니다. 다시 시도해 주세요.",
    forgotTitle: "비밀번호를 잊으셨나요?",
    forgotDescription:
      "이메일을 입력하시면 비밀번호 재설정 링크를 보내드립니다.",
    sendResetLinkButton: "재설정 링크 보내기",
    resetLinkSent:
      "이메일로 재설정 링크를 보내드렸습니다. 이 탭은 닫아도 됩니다.",
    updatePasswordTitle: "비밀번호 변경",
    updatePasswordDescription: "새 비밀번호를 입력하고 확인해 주세요.",
    newPasswordPlaceholder: "새 비밀번호를 입력하세요",
    confirmNewPasswordPlaceholder: "새 비밀번호를 한 번 더 입력하세요",
    updatePasswordButton: "비밀번호 변경",
    passwordUpdatedSuccess: "비밀번호가 변경되었습니다.",
  },
  attendancePage: {
    title: "출석체크",
    subtitle: "세션 시간에 체육관 QR을 스캔하면 이 페이지로 이동합니다.",
    auth: "로그인이 필요합니다.",
    notCrewTitle: "체육관 관원 전용",
    notCrewDescription:
      "출석 페이지는 등록된 체육관 관원(crew)만 이용할 수 있습니다. 등록 후 이용 부탁드립니다.",
    successTitle: "출석이 완료되었습니다",
    successDescription: "출석이 기록되었습니다.",
    invalidQrTitle: "QR 코드를 사용할 수 없습니다",
    invalidQrExpired: "오늘이 아닌 날의 QR이거나 만료되었습니다.",
    invalidQrGeneric: "QR 코드를 확인할 수 없습니다.",
    errOutsideSchedule: "지금은 출석 가능한 세션 시간이 아닙니다.",
    errNoMembership:
      "등록된 회원권 정보가 없습니다. 관리자에게 회원권 등록을 요청해 주세요.",
    errNoCredits: "잔여 회원권 횟수가 없습니다.",
    errOutsidePeriod: "오늘은 회원권 유효 기간 밖입니다.",
    errInvalidToken: "QR 코드가 올바르지 않거나 만료되었습니다.",
    errGeneric:
      "출석 처리에 실패했습니다. 다시 시도하거나 관리자에게 문의해 주세요.",
    errAlreadyCompleteToday: "이미 출석이 완료되었습니다.",
    passTitle: "회원권",
    passNoLabel: "라벨 없음",
    passTotal: "총 횟수(플랜)",
    passRemaining: "잔여 횟수",
    passStarts: "시작일",
    passEnds: "만료일",
    calendarTitle: "출석 달력",
    calendarHint: "초록: QR 출석일.",
    legendQr: "QR 출석",
    legendNoShow: "무단결석",
    adminQrTitle: "당일 출석 QR",
    adminQrSubtitle:
      "데스크 태블릿에 표시하세요. QR은 한국 표준시 기준 매일 바뀝니다.",
    adminQrCardTitle: "스캔 URL (오늘, 서울)",
    adminQrCardDescription:
      "관원은 로그인 후 이용합니다. QR에는 당일(서울) 날짜가 서명됩니다.",
    adminQrMissingSecret:
      "서버 환경 변수 ATTENDANCE_QR_SECRET(최소 16자)을 설정해 주세요.",
    adminQrGenerateFailed: "QR 이미지를 만들 수 없습니다.",
    adminCrewTitle: "관원 출석 관리",
    adminCrewSubtitle: "관원별 회원권·출석 달력을 확인합니다.",
    adminCrewPicker: "관원",
    adminCrewPick: "관원 선택",
    adminCrewSearch: "이름 검색…",
    adminCrewEmpty: "일치하는 관원이 없습니다.",
    adminCrewNoMembers: "crew 또는 admin 프로필이 없습니다.",
    adminExportTitle: "전체 관원 출석 현황 내보내기",
    adminExportDescription:
      "선택한 기간 내 전체 관원의 출석 현황을 엑셀 파일로 다운로드합니다.",
    adminExportFrom: "시작일",
    adminExportTo: "종료일",
    adminExportButton: "엑셀로 다운로드",
    adminExportInvalidRange: "종료일은 시작일 이후여야 합니다.",
    adminExportRangeTooLong: "출석 현황은 최대 1년까지만 내보낼 수 있습니다.",
    adminExportHint:
      "파일에는 출석 상세와 관원별 요약 두 개의 시트가 포함됩니다.",
    adminExportSingleTitle: "선택된 관원 출석 현황 내보내기",
    adminExportSingleDescription:
      "선택된 관원의 출석 현황만 엑셀 파일로 다운로드합니다.",
    adminExportSingleButton: "선택된 관원 엑셀로 다운로드",
    adminExportSingleHint:
      "선택된 관원의 출석 기록만 포함된 엑셀 파일이 생성됩니다.",
  },
  aboutCoachPage: {
    heroEyebrow: "관장 소개",
    heroName: "윤찬욱",
    heroTitle: "윤찬욱 레슬링 멀티짐(평택본관) 대표 관장",
    heroBio:
      "안녕하세요! 레슬링과 스포츠를 진심으로 사랑하는 윤찬욱의 윤찬욱 레슬링 멀티짐(평택본관)입니다.\n\n윤찬욱 관장은 10년 이상 국가대표로 활동한 레슬링 엘리트 출신으로, 대한민국과 세계 무대를 누비며 수많은 메달과 실적을 쌓아온 전직 국가대표입니다.",
    heroImageAlt: "윤찬욱 관장님 프로필 사진",
    quickRoleLabel: "직책",
    quickRoleValue: "대표 관장",
    quickSpecialtyLabel: "전문 분야",
    quickSpecialtyValue: "레슬링 · 체력 향상 · 다이어트 · 체형교정",
    quickBaseLabel: "근무지",
    quickBaseValue: "윤찬욱 레슬링 멀티짐 평택본관",
    careerTitle: "윤찬욱 관장 주요 경력",
    career: {
      c1Year: "국가대표",
      c1Text: "국가대표 선발전 다수 1위",
      c2Year: "전국체전",
      c2Text: "전국체육대회 다수 우승",
      c3Year: "2011",
      c3Text: "제29회 회장기 전국레슬링대회 일반부 84kg 1위",
      c4Year: "2014",
      c4Text: "그리스 올림피아 오픈 자유형 97kg 2위",
      c5Year: "2014",
      c5Text: "인천 아시안게임 국가대표 (수원시청 소속)",
      c6Year: "리우",
      c6Text: "리우 올림픽 국가대표 선발전 최종 우승",
      c7Year: "세계무대",
      c7Text: "세계선수권대회 다수 출전",
      c8Year: "대표팀",
      c8Text: "국가대표 주니어 대표 및 상비군",
      c9Year: "군 경력",
      c9Text: "국군체육부대 전역",
      c10Year: "학력",
      c10Text: "한국체육대학교 졸업",
    },
    certsTitle: "엘리트 경력",
    certs: {
      cert1: "10년 이상 국가대표로 활동한 레슬링 엘리트 출신",
      cert2: "대한민국과 세계 무대에서 수많은 메달과 실적을 쌓은 전직 국가대표",
      cert3: "세계적인 선수들과 다양한 시합 및 스파링 경험",
      cert4: "국가대표 훈련 시스템을 기반으로 한 체계적인 지도",
    },
    awardsTitle: "훈련 공간",
    awards: {
      a1: "레슬링, 체력 향상, 다이어트, 체형교정, 멘탈 강화까지 다양한 목표에 맞춘 훈련",
      a2: "운동 경험이 없는 분도 쉽고 즐겁게 적응할 수 있는 가족 같은 분위기",
      a3: "꿈을 이루고 싶은 분이 새로운 자신을 발견할 수 있는 열린 공간",
    },
    ctaAbout: "체육관 소개 보기",
  },
  aboutGymPage: {
    heroEyebrow: "체육관 소개",
    heroTitle: "몸과 마음이 단단해지는 공간,\n윤찬욱레슬링",
    heroDescription:
      "초보자부터 선수까지, 누구나 안전하게 레슬링을 배울 수 있도록 체계적인 커리큘럼과 따뜻한 분위기를 함께 갖춘 체육관입니다.",
    heroImageAlt: "윤찬욱레슬링 체육관 훈련 모습",
    stats: {
      foundedLabel: "설립",
      foundedValue: "2025",
      areaLabel: "매트 면적",
      areaValue: "100평",
      membersLabel: "무료 체험",
      membersValue: "예약제",
      medalsLabel: "상담 방식",
      medalsValue: "1:1",
    },
    storyEyebrow: "우리의 이야기",
    storyTitle: "기본기에서 시작해, 함께 성장합니다",
    storyParagraph1:
      "윤찬욱레슬링은 국가대표 출신 관장의 경험을 바탕으로, 처음 매트를 밟는 분도 자신감을 가질 수 있도록 기본기부터 차근차근 지도합니다.",
    storyParagraph2:
      "단순한 운동을 넘어 체력, 인내, 예의를 함께 배우는 공간을 지향합니다. 아이부터 성인까지, 취미반부터 선수반까지 각자의 목표에 맞춘 프로그램을 운영합니다.",
    storyParagraph3:
      "매주의 훈련이 작은 성취로 쌓여 큰 자신감이 되도록, 관원 한 사람 한 사람의 성장을 가장 중요하게 생각합니다.",
    storyImageAlt: "윤찬욱레슬링 단체 사진",
    featuresEyebrow: "차별점",
    featuresTitle: "윤찬욱레슬링이 다른 이유",
    featuresSubtitle:
      "체계적인 훈련 시스템과 경험 많은 지도진, 쾌적한 시설이 한곳에 모여 있습니다.",
    feature1Title: "전문 지도진",
    feature1Description:
      "국가대표 및 실전 경험을 갖춘 지도자가 직접 1:1 피드백을 제공합니다.",
    feature2Title: "체계적인 커리큘럼",
    feature2Description:
      "초보자 기술반부터 선수반까지 단계별 프로그램으로 흐름을 놓치지 않습니다.",
    feature3Title: "쾌적한 훈련 환경",
    feature3Description:
      "넓은 매트와 샤워실·라커 등 기본에 충실한 시설로 훈련에만 집중할 수 있습니다.",
    feature4Title: "안전 우선",
    feature4Description:
      "부상 예방을 위한 준비운동·낙법 교육과 체급·수준별 파트너 매칭을 실시합니다.",
    visitEyebrow: "방문 안내",
    visitTitle: "직접 방문해 체험해보세요",
    visitDescription:
      "무료 체험은 사전 예약제로 운영됩니다. 아래 버튼으로 편하게 문의해 주세요.",
    visitAddressLabel: "주소",
    visitAddress: "경기 평택시 경기대로 1409 4층",
    visitHoursLabel: "운영시간",
    visitHours: "월·화·목 17:00 – 22:00\n수 19:00 – 21:00",
    visitImageAlt: "윤찬욱레슬링 시설 사진",
    ctaContact: "상담·체험 신청",
    ctaSchedule: "수업 시간표 보기",
    ctaFacilities: "시설 둘러보기",
  },
  programsInfoPage: {
    heroEyebrow: "프로그램 소개",
    heroTitle: "기본기에서 실전까지,\n체계적으로 성장하는 훈련",
    heroDescription:
      "연령과 수준에 맞춘 단계별 커리큘럼으로, 처음 시작하는 분도 꾸준히 성장할 수 있도록 돕습니다. 매트 위의 모든 순간을 의미 있게 만드는 것이 목표입니다.",
    heroImageAlt: "윤찬욱레슬링 훈련 모습",
    pillarsEyebrow: "훈련 구성",
    pillarsTitle: "4가지 기둥으로 균형 있게",
    pillarsSubtitle:
      "기술, 체력, 실전 감각, 안전 — 어느 하나도 치우치지 않도록 전 레벨에 걸쳐 균형 있게 다룹니다.",
    pillar1Title: "기본기 · 테크닉",
    pillar1Description:
      "자세, 그립, 태클, 방어 등 모든 기술의 토대가 되는 기본 동작을 반복 숙달합니다.",
    pillar2Title: "피지컬 · 체력",
    pillar2Description:
      "레슬링 특화 유산소 · 코어 · 웨이트로 매트 위에서 끝까지 버티는 체력을 만듭니다.",
    pillar3Title: "실전 감각",
    pillar3Description:
      "드릴과 라이브 스파링을 통해 실제 경기에서 쓰이는 판단력과 반응속도를 기릅니다.",
    pillar4Title: "안전 · 회복",
    pillar4Description:
      "준비운동·정리운동, 낙법, 부상 예방 루틴으로 오래 지속할 수 있는 훈련을 만듭니다.",
    tracksEyebrow: "프로그램 트랙",
    tracksTitle: "목표에 따라 고르는 두 가지 길",
    tracksSubtitle:
      "취미로 즐기고 싶은 분, 시합을 준비하는 분 모두에게 맞는 프로그램을 운영합니다.",
    amateurTitle: "아마추어 프로그램",
    amateurTag: "취미 · 생활체육",
    amateurDescription:
      "처음 레슬링을 접하는 분부터, 꾸준히 운동하며 즐기고 싶은 분까지 편하게 참여할 수 있습니다.",
    amateur: {
      f1: "주 3회 기본기 · 테크닉 수업",
      f2: "수준에 맞춘 파트너 매칭",
      f3: "다이어트 · 체력 향상에 적합",
      f4: "선수 경험 없이도 시작 가능",
    },
    eliteTitle: "엘리트 선수 프로그램",
    eliteTag: "시합 · 선수반",
    eliteDescription:
      "대회 출전과 꾸준한 기량 향상을 목표로 하는 분을 위한 고강도 훈련 트랙입니다.",
    elite: {
      f1: "시합 일정에 맞춘 주간 계획",
      f2: "테크닉 · 라이브 스파링 심화",
      f3: "체급 관리 · 컨디셔닝 상담",
      f4: "지도자 1:1 피드백 제공",
    },
    trackLearnMore: "자세히 보기",
    pathEyebrow: "수준별 학습 경로",
    pathTitle: "입문부터 시합까지, 당신의 속도로",
    pathSubtitle:
      "서두르지 않고 단계를 차곡차곡 밟을 수 있도록 3단계의 학습 경로를 제시합니다.",
    level1Title: "입문 단계",
    level1Description:
      "준비운동 · 낙법 · 기본 스탠스. 레슬링의 언어를 몸으로 익힙니다.",
    level1Duration: "약 4–8주",
    level2Title: "기초 · 중급 단계",
    level2Description:
      "대표 기술(태클, 그립 파이팅, 파테르)을 반복 숙달하고 드릴을 늘려갑니다.",
    level2Duration: "약 3–6개월",
    level3Title: "심화 · 실전 단계",
    level3Description:
      "라이브 스파링 비중을 높이고, 원하는 경우 시합 출전을 준비합니다.",
    level3Duration: "6개월 이후",
    finalCtaTitle: "당신에게 맞는 시작점을 함께 찾습니다",
    finalCtaDescription:
      "현재 체력, 목표, 가능한 요일만 알려주시면 가장 잘 맞는 프로그램을 추천해 드립니다.",
    ctaContact: "무료 상담 신청",
    ctaSchedule: "시간표 보기",
  },
  programsPage: {
    scheduleTitle: "프로그램 시간표",
    scheduleSubtitle: "체육관의 주간 수업 일정입니다.",
    day: {
      mon: "월",
      tue: "화",
      wed: "수",
      thu: "목",
      fri: "금",
    },
    label: {
      wrestling: "레슬링",
      sparring: "스파링",
      beginnerDrills: "초보자 기술연습",
      and: "&",
    },
    legendSparring: "수요일 스파링 · 초보자 기술연습",
    legendClosed: "휴관",
  },
  dashboardPage: {
    adminTitle: "관리자 대시보드",
    adminSubtitle: "오늘의 운영 현황과 최근 출석 추이를 한눈에 확인합니다.",
    crewTitle: "내 대시보드",
    crewSubtitle: "회원권 잔여 횟수와 이번 주 출석 현황입니다.",
    memberTitle: "대시보드",
    memberSubtitle: "가입해 주셔서 감사합니다.",
    memberEmptyTitle: "아직 회원권이 없습니다",
    memberEmptyDescription:
      "체육관에 방문하여 회원권을 등록한 뒤 출석 기능을 이용할 수 있습니다.",
    todayCheckIns: "오늘 체크인 인원",
    todayLabel: "오늘",
    newMembersThisMonth: "이번 달 신규 회원",
    newMembersDescription: "이번 달에 새로 가입한 회원 수",
    expiringSoon: "회원권 만료 임박 ({{days}}일 이내)",
    expiringRange: "{{from}} ~ {{to}}",
    expiringListTitle: "만료 임박 관원",
    expiringListDescription:
      "앞으로 {{days}}일 안에 회원권이 끝나는 관원입니다.",
    expiringEmpty: "만료 예정인 관원이 없습니다.",
    trendTitle: "최근 {{days}}일 출석 추이",
    trendRange: "{{from}} ~ {{to}}",
    myRemaining: "나의 잔여 횟수",
    myRemainingOfTotal: "총 {{total}}회 중",
    myRemainingNoPlan: "등록된 회원권이 없습니다",
    weeklyAttendance: "이번 주 출석",
    weeklyRange: "{{from}} ~ {{to}}",
    expiryCountdown: "회원권 만료",
    expiresOn: "만료일: {{date}}",
    noExpiry: "만료일 정보가 없습니다",
    expired: "만료됨",
    dayToday: "오늘",
    dayDMinus: "D-{{days}}",
  },
  membersPage: {
    title: "회원 관리",
    subtitle: "회원을 선택해 가입 정보를 확인하고 권한을 변경할 수 있습니다.",
    picker: "회원 선택",
    pick: "회원을 선택하세요",
    search: "이름 검색…",
    empty: "일치하는 회원이 없습니다.",
    noMembers: "관리자를 제외한 회원이 없습니다.",
    accountInfoTitle: "가입 정보",
    accountInfoDescription: "회원이 가입 시 입력한 정보입니다 (비밀번호 제외).",
    fieldName: "이름",
    fieldEmail: "이메일",
    fieldEmailConfirmed: "이메일 인증 시각",
    fieldPhone: "전화번호",
    fieldMarketing: "마케팅 수신 동의",
    fieldCurrentRole: "현재 권한",
    fieldNewRole: "변경할 권한",
    fieldCreatedAt: "가입일",
    fieldLastSignIn: "최근 로그인",
    yes: "예",
    no: "아니오",
    roleTitle: "권한 변경",
    roleDescription:
      "회원의 권한을 member 또는 crew로 변경할 수 있습니다. 관리자 권한은 변경할 수 없습니다.",
    selectRolePlaceholder: "권한 선택",
    roleMember: "member",
    roleCrew: "crew",
    saveRole: "권한 저장",
    saving: "저장 중…",
    saved: "권한이 변경되었습니다.",
    errorCannotChangeAdmin: "관리자 권한은 이 페이지에서 변경할 수 없습니다.",
    errorForbidden: "권한이 없습니다.",
    errorGeneric: "권한 변경에 실패했습니다.",
    membershipTitle: "회원권 정보",
    membershipNoLabel: "라벨 없음",
    membershipEditDescription:
      "crew 관원의 회원권 정보를 관리자가 직접 입력/수정할 수 있습니다. 비워두면 저장 시 해당 항목이 삭제(null)됩니다.",
    fieldMembershipLabel: "회원권 라벨 (주3회, 주4회, 선수반 등)",
    membershipLabelPlaceholder: "예: 주 3회 월 12회권",
    fieldMembershipTotal: "총 횟수",
    fieldMembershipRemaining: "잔여 횟수",
    fieldMembershipStarts: "시작일",
    fieldMembershipEnds: "종료일",
    saveMembership: "회원권 저장",
    membershipSaved: "회원권이 저장되었습니다.",
    errorRemainingGtTotal: "잔여 횟수는 총 횟수보다 클 수 없습니다.",
    errorEndsBeforeStarts: "종료일은 시작일 이후여야 합니다.",
    errorInvalidNumber: "숫자는 0 이상의 정수여야 합니다.",
    errorInvalidDate: "날짜 형식이 올바르지 않습니다.",
    errorNotCrew: "crew 권한의 회원만 회원권을 설정할 수 있습니다.",
  },
};

export default ko;
